import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importar las traducciones
import en from './locales/en.json';
import es from './locales/es.json';
import pt from './locales/pt.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import zh from './locales/zh.json';
import ar from './locales/ar.json';
import hi from './locales/hi.json';
import ru from './locales/ru.json';
import ja from './locales/ja.json';

i18n
  // Detectar el idioma del navegador
  .use(LanguageDetector)
  // Pasar la instancia de i18n a react-i18next
  .use(initReactI18next)
  // Inicializar i18next
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      pt: { translation: pt },
      fr: { translation: fr },
      de: { translation: de },
      zh: { translation: zh },
      ar: { translation: ar },
      hi: { translation: hi },
      ru: { translation: ru },
      ja: { translation: ja },
    },
    fallbackLng: 'es',
    lng: 'es',
    detection: {
      order: ['localStorage', 'querystring'],
      lookupLocalStorage: 'language',
      caches: ['localStorage'],
    },
    debug: false,
    interpolation: {
      escapeValue: false, // React ya escapa por defecto
    },
  });

export default i18n;




